import React from 'react'

const Container = ({ children, fluid, ...props }) => (
  <div className={fluid ? 'container-fluid' : 'container'} {...props}>
    {children}
  </div>
)

export { Container }
